import { LANGUAGE } from "2g-i18n";

import MESSAGES_CZECH from "./cs";
import MESSAGES_ENGLISH from "./en";

export default {
  [LANGUAGE.CZECH]: MESSAGES_CZECH,
  [LANGUAGE.ENGLISH]: MESSAGES_ENGLISH
};
